<template src="./categoriesExport.html"></template>

<script>
import VueResizable from 'vue-resizable'
import goodsTopMenu from '../components/topMenu';
import BrandSelect from "@/components/components/BrandSelect.vue";
import LanguagesSelect from "@/components/components/LanguagesSelect.vue";
import {config} from "@/config";
import axios from "axios";
export default {
  name: "CategoriesExport",
  components: {
    BrandSelect,
    LanguagesSelect,
    VueResizable,
    goodsTopMenu
  },
  data() {
    return {
      brand: null,
      language: null,
      isButtonEnabled: false,
    }
  },

  methods: {
    brandsChange(brand) {
      this.brand = brand;
      this.validateSelection();
    },
    languageChange(language) {
      this.language = language;
      this.validateSelection();
    },
    validateSelection() {
      // Enable button only when both brand and language are selected
      this.isButtonEnabled = this.brand && this.language;
    },
    async exportCategories() {
      if (!this.isButtonEnabled) {
        // TODO Replace by some project notification
        alert("Please select both brand and language.");
        return;
      }

      try {
        // Send parameters to backend
        const response = await axios.post(
            `${config.apiUrl}categories/export`,
            {
              brand: this.brand.id,
              language: this.language,
            },
            {
              responseType: "blob", // Ensure we get the binary data as a Blob
            }
        );

        // Create a Blob from the response data
        const blob = new Blob([response.data], {
          type: response.headers["content-type"],
        });

        // Extract filename from the Content-Disposition header
        const contentDisposition = response.headers["content-disposition"];
        const filename = contentDisposition
            ?.match(/filename="?([^"]+)"?/)?.[1] || `categories_${this.brand.id}_${this.language}.xlsx`;

        // Create a link element and trigger download
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = filename;
        document.body.appendChild(a);
        a.click();

        // Cleanup
        document.body.removeChild(a);
        window.URL.revokeObjectURL(url);
      } catch (error) {
        console.error("Error during export:", error);
        // TODO Replace by some project notification
        alert("An error occurred. Please try again later.");
      }
    },
  },

  // ============================__COMPUTED__============================

  mounted() {
    if (this.$store.getters.getAllowSection.indexOf('product') === -1) {
      this.$router.push({name: 'permissionDenied'});
      return;
    }
    this.windowResize();
    this.setMainTableTop();
  },
  created() {
    //this.activeOptionsList = this.fullOptionsList
    window.addEventListener("resize", this.windowResize);
  },
  destroyed() {
    window.removeEventListener("resize", this.windowResize);
  },

}
</script>

<style scoped>
/* Add basic styles */
.export-button {
  padding: 8px 16px;
  background-color: #4CAF50;
  color: white;
  border: none;
  cursor: pointer;
  font-size: 14px;
  border-radius: 4px;
}

.export-button:disabled {
  background-color: #ccc;
  cursor: not-allowed;
}
</style>

<style>
.goods-import thead th {
  height: 4.5rem;
}

.goods-import .error-table thead th {
  height: 2rem !important;
}

.goods-import .b-table-sticky-header > .table.b-table > thead > tr > th {
  top: -1px !important;
}

.goods-import .goods-import tr th:first-child {
  width: 5%;
}

.goods-import .table th, .goods-import .table td {
  padding: 0;
  vertical-align: middle;
}

.goods-import html {
  overflow-x: hidden;
}
</style>